import { Phone, PhoneOff } from "lucide-react";
import { initials } from "@/lib/format";

// Global stack of incoming call cards (shows regardless of which chat is open).
export function IncomingCallStack({ incoming, onAccept, onReject, accent = "#2ac67b" }) {
  if (!incoming || incoming.length === 0) return null;
  return (
    <div className="fixed right-4 top-4 z-[70] flex w-[300px] max-w-[calc(100vw-2rem)] flex-col gap-2.5" data-testid="incoming-call-stack">
      {incoming.map((c) => (
        <div
          key={c.conversationId}
          className="sc-slide-in flex items-center gap-3 rounded-2xl border border-white/10 bg-[#0d1a16]/95 p-2.5 shadow-2xl backdrop-blur-xl"
          data-testid={`incoming-call-${c.conversationId}`}
        >
          <div
            className="sc-pulse-ring flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold"
            style={{ background: accent, color: "#04120c" }}
          >
            {initials(c.callerName)}
          </div>
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-semibold text-white">{c.callerName}</div>
            <div className="text-xs text-white/50">Incoming voice call…</div>
          </div>
          <button
            onClick={() => onReject(c.conversationId)}
            className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-red-500 text-white transition-transform hover:scale-105"
            data-testid={`incoming-reject-${c.conversationId}`}
            aria-label="Decline call"
          >
            <PhoneOff className="h-4 w-4" aria-hidden="true" />
          </button>
          <button
            onClick={() => onAccept(c.conversationId)}
            className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#22c55e] text-white transition-transform hover:scale-105"
            data-testid={`incoming-accept-${c.conversationId}`}
            aria-label="Accept call"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>
  );
}
